// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div#layout-default[data-v-955efa24]{background:#ecedf6;min-height:100vh}.page-enter-active[data-v-955efa24]{-webkit-animation:enter-data-v-955efa24 .5s ease-in;animation:enter-data-v-955efa24 .5s ease-in}.page-leave-active[data-v-955efa24]{animation:enter-data-v-955efa24 .5s ease-out reverse}@-webkit-keyframes enter-data-v-955efa24{0%{opacity:0}to{opacity:1}}@keyframes enter-data-v-955efa24{0%{opacity:0}to{opacity:1}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
